// src/components/CustomerOrderPage/PoweredByFooter.jsx
// Reusable footer component for customer pages.
// tone="dark" for pages with the deep-purple hero backdrop.

import React from 'react';

const PoweredByFooter = ({ tone = 'light' }) => {
	const dark = tone === 'dark';
	return (
		<footer
			style={{
				textAlign: 'center',
				padding: '16px 20px',
				backgroundColor: 'transparent',
				borderTop: dark ? '1px solid rgba(255, 255, 255, 0.12)' : '1px solid rgba(61, 30, 109, 0.1)',
				color: dark ? 'rgba(255, 255, 255, 0.6)' : '#6b7280',
				fontSize: '12px',
				position: 'relative',
				zIndex: 1,
			}}
		>
			Powered by{' '}
			<a
				href="/"
				target="_blank"
				rel="noopener noreferrer"
				style={{
					color: dark ? '#FB8601' : '#3D1E6D',
					textDecoration: 'none',
					fontWeight: '700',
				}}
			>
				Eventory
			</a>
		</footer>
	);
};

export default PoweredByFooter;
